import { Component, Input, EventEmitter, Output, ChangeDetectionStrategy, ViewEncapsulation, ElementRef, ViewChild, AfterViewInit, OnChanges, SimpleChanges } from '@angular/core';
import { Category, SubCategory } from '@jms/model';
import { CatagoryChangedEventArgs } from '../../model';

@Component({
    selector: 'code-categories',
    templateUrl: 'code.categories.html',
    styleUrls: ['code.categories.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class CodeCategoriesComponent implements AfterViewInit, OnChanges {

  @Input() public categories: Category[];
  @Input() public selectedCategory: Category = null;
  @Input() public selectedSubcategory: SubCategory = null;

  @Output() public categoryChanged = new EventEmitter<CatagoryChangedEventArgs>();

  @ViewChild('selectedItem') selectedItem: ElementRef;

  constructor() { }

  ngOnChanges(changes: SimpleChanges): void {
    this.raiseCategoryChanged();
  }

  ngAfterViewInit() {
    if (this.selectedItem) {
      this.selectedItem.nativeElement.scrollIntoView({ behavior: 'auto', block: 'center' });
    }
  }

  public onSelectCategory(category: Category) {

    // Set or clear category
    this.selectedCategory = (category?.name === this.selectedCategory?.name)
      ? null
      : category;

    // Clear subcategory
    this.selectedSubcategory = null;

    this.raiseCategoryChanged();
  }

  public onSelectSubCategory(subCategory: SubCategory) {

    // Set or clear sub category
    this.selectedSubcategory = (subCategory?._id === this.selectedSubcategory?._id)
      ? null
      : subCategory;

    this.raiseCategoryChanged();

  }

  private raiseCategoryChanged() {

    this.categoryChanged.next({
      category: this.selectedCategory,
      subcategory: this.selectedSubcategory
    });

  }

}
